<template>
<div class="collapse-content">
  <div
    class="collapse-transition-box"
    ref="transitionBox"
    :style="{height: finallyContenHeight}"
  >
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  name: '',
  components: {},
  inject: ['minHeight', 'getExpand', 'setExpand', 'getHideExpandBtn'],
  data() {
    return {
      contentHeight: this.minHeight,
      timer: null,
    };
  },
  computed: {
    expand: {
      get() {
        return this.getExpand();
      },
      set(value) {
        return this.setExpand(value);
      },
    },
    hideExpandBtn() {
      return this.getHideExpandBtn();
    },
    finallyContenHeight() {
      if (this.hideExpandBtn) {
        // 没有展开收起，直接全部显示
        return '';
      } else if (!this.contentHeight && this.contentHeight !== 0) {
        return '';
      }
      return `${this.contentHeight}px`;
    },
  },
  watch: {
    expand: {
      handler() {
        this.calcContentHeight();
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    calcContentHeight() {
      this.$nextTick(() => {
        clearInterval(this.timer);
        if (this.expand) {
          this.contentHeight = this.$refs.transitionBox.scrollHeight;
          // 动画结束后，把高度设置回元素本身的高度
          this.timer = setTimeout(() => {
            this.contentHeight = undefined;
          }, 150);
        } else {
          // 先设置高度，再变成0.这样才有动画
          if (this.contentHeight === undefined) {
            this.contentHeight = this.$refs.transitionBox.scrollHeight;
          }
          setTimeout(() => {
            this.contentHeight = this.minHeight;
          }, 0);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.collapse-transition-box{
  transition: height .15s ease-in-out,padding-top .15s ease-in-out,padding-bottom .15s ease-in-out;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/common/collapse/collapse-content.vue